// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"36d8f74e","50":"9e53bf02","61":"6b41ee5c","69":"be6ce12d","95":"8101dcbb","183":"549a8155","305":"e911f5cc","324":"66f20ae2","429":"c233ed0a","483":"25cda2f3","563":"251af7b8","692":"bf9a2360","770":"bc0c8457","787":"6857abc5"}[chunkId] + ".chunk.js";
};